import numeral from 'numeral';

export function parseNumber(value: string | undefined): number | undefined {
  if (value === undefined) {
    return undefined;
  }
  return numeral(value).value();
}
